import * as GeneralRepository from "./general-repository";
import * as CotizacionProvider from "../providers/cotizacion-provider";

export const listarCotizaciones = async (idProspecto) => {
    const response = await CotizacionProvider.getCotizaciones(idProspecto)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            cotizaciones: response.entity.datos
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await listarCotizaciones(idProspecto)
            } else {
                return {
                    error: response.auditResponse,
                    cotizaciones: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                cotizaciones: null
            }
        }
    }
}

export const obtenerCotizacionxProspecto = async (idProspecto, codigoCotizacion) => {
    const response = await CotizacionProvider.getDetalleCotizacion(idProspecto, codigoCotizacion)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            cotizacion: response.entity.datos
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerCotizacionxProspecto(idProspecto, codigoCotizacion)
            } else {
                return {
                    error: response.auditResponse,
                    cotizacion: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                cotizacion: null
            }
        }
    }
}